import { LoadingButton } from '@mui/lab';
import { DialogTitle, FormControl, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import useEditPartNode from 'api/locationsCategories/useEditPartNode';
import { useForm } from 'react-hook-form';

import { partFieldValidationValues } from '../constants';

const EditPartNodeModal = props => {
  const { guid, defaultName } = props;

  const [editLoading, editPartNode] = useEditPartNode();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues: {
      name: defaultName || '',
    },
  });

  const onSubmit = data => {
    editPartNode(guid, data.name, props.refreshData);
  };

  const handleClose = () => {
    props.closeHandler();
    reset({
      name: defaultName || '',
    });
  };

  return (
    <Dialog
      open={props.show}
      onClose={handleClose}
      sx={{ direction: 'rtl' }}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          handleSubmit(onSubmit)();
        }
      }}
    >
      <DialogTitle>آپدیت بخش</DialogTitle>

      <DialogContent>
        <FormControl sx={{ m: 1, minWidth: 300 }}>
          <TextField
            autoFocus
            label="عنوان بخش"
            variant="standard"
            {...register('name', partFieldValidationValues)}
            error={isSubmitted ? !!errors.name : false}
            helperText={errors.name?.message || ''}
          />
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={editLoading}
          onClick={handleSubmit(onSubmit)}
        >
          تایید
        </LoadingButton>

        <LoadingButton
          variant="contained"
          color="warning"
          loading={editLoading}
          onClick={handleClose}
        >
          انصراف
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default EditPartNodeModal;
